// TODO refatorar para array
export const AuthInsuranceClients = Object.freeze({
  SULAMERICA: {
    code: '63',
  }
});
export const AuthUnits = Object.freeze({
  // SALOMAOZOPPI_PARAISO: {
  //   name: 'Paraiso',
  //   unitId: 1156,
  // },
  // LAVOISIER_FCOMORATO: {
  //   name: 'Fco Morato',
  //   unitId: '866',
  // },
  LAVOISIER_ANGELICAII: {
    name: 'Angélica II',
    unitId: '846',
  },
});
